import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import endpoints from '../endpoints.ts';
import api from '../api/index.ts';
import { OutboundDocumentStatusAPI } from '../api/outboundDocumentStatus.ts';

export const OUTBOUND_DOCUMENT_STATUS_QUERY_KEY =
  'OUTBOUND_DOCUMENT_STATUS_QUERY_KEY';

const useReadStatusCountByUserId = (
  options?: Partial<
    UseQueryOptions<
      OutboundDocumentStatusAPI.Response.ReadStatusCountByUserId[] | null
    >
  >
) =>
  useQuery({
    queryKey: [
      OUTBOUND_DOCUMENT_STATUS_QUERY_KEY,
      endpoints.outboundDocumentStatus.read.statusCount.by.userId(),
    ],
    queryFn: api.outboundDocumentStatus.read.statusCount.by.userId,
    ...options,
  });

const outboundDocumentStatus = {
  useReadStatusCountByUserId,
};

export default outboundDocumentStatus;
